<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服工作站</el-breadcrumb-item>
        <el-breadcrumb-item>售后与设备维护</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="(page) => onLoad(page, params)"
      @row-save="saveSales"
      @row-update="updateSales"
      @row-del="deleteSales"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"> </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getDetail, enable, disable } from "@/api/health/userjk";
import { getSales, saveOrUpdateSales, deleteSales } from "@/api/health/manage";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      params: {
        channel: window.localStorage.getItem("channel"),
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        indexLabel: "序号",
        tip: false,
        border: false,
        index: true,
        viewBtn: true,
        editBtn: true,
        addBtn: true,
        addBtnText: "新 增 数 据",
        delBtn: true,
        selection: true,
        searchSpan: 4,
        searchEnter: true,
        column: [
          {
            label: "工单ID",
            prop: "id",
            search: true,
            detail: true,
            width: 170,
          },
          {
            label: "工单类型",
            prop: "type",
            search: true,
            type: "select",
            dicData: [
              { label: "操作指导", value: 0 },
              { label: "维修", value: 1 },
              { label: "更换", value: 2 },
            ],
          },
          {
            label: "工单状态",
            prop: "status",
            search: true,
            type: "select",
            dicData: [
              { label: "待处理", value: 0 },
              { label: "处理中", value: 1 },
              { label: "已关闭", value: 2 },
            ],
          },
          {
            label: "处理进度",
            prop: "progress",
          },
          {
            label: " 故障描述",
            prop: "record",
            width: 170,
            overHidden: true,
          },
          {
            label: "更换记录",
            prop: "isreplace",
            search: true,
            type: "select",
            dicData: [
              { label: "未更换", value: 0 },
              { label: "已更换", value: 1 },
            ],
          },
          {
            label: "新设备",
            prop: "oldSn",
            search: true,
            width: 170,
          },
          {
            label: "旧设备",
            prop: "newSn",
            search: true,
            width: 170,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    onLoad(page, params) {
      console.log("onLoad?");
      params.channel = window.localStorage.getItem("channel");
      getSales(page.currentPage, page.pageSize, params).then((res) => {
        console.log(res.data);
        this.page.total = res.data.total;
        this.data = res.data.sales;
      });
    },

    saveSales(row, done, loading) {
      console.log("save?");
      row.channel = window.localStorage.getItem("channel");
      saveOrUpdateSales(row)
        .then(() => {
          done();
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "添加成功!",
          });
        })
        .catch(() => {
          this.onLoad(this.page, this.params);
        });
    },

    updateSales(row, index, done, loading) {
      // row.channel = window.localStorage.getItem("channel");
      if (row.id == null) {
        done();
        this.$message.success("数据未修改!");
        return;
      }
      saveOrUpdateSales(row)
        .then(() => {
          done();
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "修改成功!",
          });
        })
        .catch(() => {
          this.onLoad(this.page, this.params);
        });
    },

    deleteSales(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return deleteSales(row);
        })
        .then(() => {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    },

    searchChange(params, done) {
      console.log("SeachChange?");
      params.channel = window.localStorage.getItem("channel");
      this.params = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem("channel"),
      };
      this.onLoad(this.page, this.params);
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    handleEnable() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定对该用户启用VIP嘛?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return enable(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    handleDisable() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定对该用户停用VIP嘛?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return disable(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data;
        });
      }
      done();
    },

    archiveType(row) {
      console.log(row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/health/archiveType",
        query: parameter,
      });
    },
  },
};
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
